export default function() {
  return [
    {
      title: "Ricotta Blog",
      to: "/birthdays/dashboard/index",
      htmlBefore: '<i class="material-icons">article</i>',
      htmlAfter: ""
    },
    {
      title: "Birthdays Billing Dashboard",
      htmlBefore: '<i class="material-icons">credit_card</i>',
      to: "/birthdays/dashboard/billing",
      htmlAfter: ""
    }
  ];
}

